var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._g({staticClass:"pui-header-button pui-header-button__root"},_vm.$listeners),[_c('a',{staticClass:"pui-header-button__link"},[(_vm.picto)?_c('span',{class:{ 'pui-header-button__picto mdi': true, [_vm.picto]: !!_vm.picto }}):_vm._e(),_c('span',{staticClass:"pui-header-button__label"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }